import React, { useRef, useEffect } from 'react';

const Canvas = (props) => {
  const { gridData, data, height, width, ...rest } = props;
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    context.beginPath();
    context.fillStyle = '#ccc';
    context.fillRect(0, 0, width, height);
    context.stroke();
    if (data) {
      data.elements.forEach((element) => {
        context.beginPath();
        context.fillStyle = '#cccddd';
        context.fillRect(element.x, element.y, element.lengthOnGrid, element.widthOnGrid);
        context.strokeStyle = '#0000ff';
        context.lineWidth = 2;
        context.strokeRect(element.x, element.y, element.lengthOnGrid, element.widthOnGrid);
      });
    }

    return () => {
      // window.cancelAnimationFrame(animationFrameId);
    };
  }, [data]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    const horizontalSide = gridData.lengthonplane;
    const verticalSide = gridData.widthonplane;

    context.beginPath();
    context.fillStyle = '#ccc';
    context.fillRect(0, 0, horizontalSide, verticalSide);
    context.stroke();

    gridData.elements.forEach((element) => {
      context.beginPath();
      context.fillStyle = '#cccddd';
      context.fillRect(element.x, element.y, element.lengthongrid, element.widthongrid);
      context.strokeStyle = '#0000ff';
      context.lineWidth = 2;
      context.strokeRect(element.x, element.y, element.lengthongrid, element.widthongrid);
    });

    return () => {
      // window.cancelAnimationFrame(animationFrameId);
    };
  }, [gridData]);

  return <canvas ref={canvasRef} {...rest} width={gridData.lengthonplane} height={gridData.widthonplane} />;
};

export default Canvas;
